// extracted by mini-css-extract-plugin
export default {"productCarousel":"IY-z"};